import { ReactElement } from "react";
import { graphql } from "gatsby";
import * as styles from "./termsOfService.module.scss";
import Helmet from "../../components/Helmet";

interface ISpecialOffer {
    data: GatsbyTypes.TermsOfServicePageQuery;
}

export default function TermsOfService({ data }: ISpecialOffer): ReactElement {
    return (
        <section className={styles.termsOfServicePage}>
            <Helmet title={data.strapi.termsOfService?.base?.heading} description={""} />
            <div className="headerContainer">
                <div className="mainBox">
                    <h1>{data.strapi.termsOfService?.base?.heading}</h1>
                </div>
            </div>

            <div className={styles.wrapper}>
                <div className={styles.inner}>
                    <div dangerouslySetInnerHTML={{ __html: data.strapi.termsOfService?.base?.paragraph ?? "" }}></div>
                </div>
            </div>
        </section>
    );
}

export const query = graphql`
    query TermsOfServicePage {
        strapi {
            termsOfService {
                base {
                    heading
                    paragraph
                }
            }
        }
    }
`;
